import './Title.scss'

import cn from 'classnames'

export type ITitle = {
  children: React.ReactNode
  align?:
    | 'start'
    | 'center'
    | 'inherit'
    | 'initial'
    | 'unset'
    | 'end'
    | 'justify'
    | 'left'
    | 'right'
  tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span'
  color?: 'main' | 'secondary' | 'inherit'
  size?: 's' | 'm' | 'l' | 'xl'
  weight?: 'm' | 'l' | 'xl'
  className?: string
  ellipsis?: boolean
}

const Title = ({
  children,
  className,
  tag = 'h2',
  color = 'inherit',
  size = 'l',
  weight = 'm',
  align = 'inherit',
  ellipsis = false,
}: ITitle) => {
  const Tag = tag

  return (
    <Tag
      className={`${cn(
        'title',
        `title--color-${color}`,
        `title--size-${size}`,
        `title--align-${align}`,
        `title--weight-${weight}`,
        {
          [`${className}`]: !!className,
          'title--is-ellipsis': ellipsis,
        },
      )}`}
    >
      {children}
    </Tag>
  )
}

export default Title
